import React from "react";
import {useUserMetaData} from "../../../contexts";
import {MainMenuProvider} from "./context/MenuContext";
import ConsumerMenuContent from "./ConsumerMenuContent";
import ConsumerMenuDrawer from "./ConsumerMenuDrawer";

const MainMenu = () => {
  const {loggedIn} = useUserMetaData();

  if (!loggedIn) return null;

  return (
    <MainMenuProvider>
      <ConsumerMenuDrawer>
        <ConsumerMenuContent />
      </ConsumerMenuDrawer>
    </MainMenuProvider>
  );
};

export default MainMenu;
